import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import PasswordInput from './password-input';
import PasswordPopup from '../../password-popup';

import {
  Title,
  Text,
  Label,
  Button,
  BottomContainer,
  ErrorMessage,
  Loader,
} from '../styles';

const ResetPasswordForm = (props) => {
  const {
    onFieldClick,
    errors,
    onChange,
    onClick,
    touched,
    submitError,
    onShowPasswordClick,
    type,
    newPassword,
    isSubmitting,
  } = props;

  const [passwordPopupOpen, setPasswordPopupOpen] = useState(false);
  const loaderColor = { color: { loader: '#FCFCFC' } };

  const handleFocus = useCallback(() => {
    setPasswordPopupOpen(true);
    onFieldClick('newPassword');
  }, [onFieldClick, setPasswordPopupOpen]);

  const handleBlur = useCallback(() => {
    setPasswordPopupOpen(false);
  }, [setPasswordPopupOpen]);

  return (
    <>
      <Title>Reset your password</Title>

      <Text>Please set a new password for your account.</Text>

      <PasswordPopup
        isOpen={passwordPopupOpen}
        password={newPassword}
        isReset
      />

      <Label>New password</Label>
      <PasswordInput
        name="newPassword"
        type={type}
        fluid
        onFocus={handleFocus}
        onBlur={handleBlur}
        onShowPasswordClick={onShowPasswordClick}
        errors={errors}
        touched={touched}
        onChange={(e, { value }) => onChange(value, 'newPassword')}
      />

      <Label>Confirm password</Label>
      <PasswordInput
        name="confirmPassword"
        type={type}
        fluid
        onShowPasswordClick={onShowPasswordClick}
        onClick={() => onFieldClick('confirmPassword')}
        errors={errors}
        touched={touched}
        onChange={(e, { value }) => onChange(value, 'confirmPassword')}
      />

      <BottomContainer>
        <Button
          type="submit"
          onClick={onClick}
          disabled={isSubmitting && !submitError}
        >
          { (isSubmitting && !submitError)
            ? <Loader active inline size="tiny" theme={loaderColor} />
            : 'Set Password'}
        </Button>
        {submitError && (
          <ErrorMessage>Something went wrong. Please try again later</ErrorMessage>
        )}
      </BottomContainer>
    </>
  );
};

ResetPasswordForm.propTypes = {
  onFieldClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  submitError: PropTypes.bool,
  type: PropTypes.string.isRequired,
  onShowPasswordClick: PropTypes.func.isRequired,
  newPassword: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

ResetPasswordForm.defaultProps = {
  submitError: false,
};

export default ResetPasswordForm;
